import script from "./TitlePoster.vue?vue&type=script&setup=true&lang=js"
export * from "./TitlePoster.vue?vue&type=script&setup=true&lang=js"

import "./TitlePoster.vue?vue&type=style&index=0&id=564471dd&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-564471dd"]])

export default __exports__